import RestError from '../app/errors';

export default class OneOfSlipsNotFoundError extends RestError {}
